import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { RecipientGroup } from '../message';
import { Subscription } from 'rxjs';
import { MessageService } from '../message.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomEmail } from '../../shared';
import { Message } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { GlobalService } from '../../core';

@Component({
  selector: 'app-add-message',
  templateUrl: './add-message.component.html',
  styleUrls: ['./add-message.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmationService]
})
export class AddMessageComponent implements OnInit, OnDestroy {
  items: SelectItem[];
  recipientGroup: RecipientGroup;
  subscription: Subscription;
  processing = false;
  recipients = false;
  messages: Message[] = [];
  files: File[];
  propertyId: number;
  displayItems = [];
  canSendMessagesToExternal = this._global.find((<any>_GlobalNS).paths.canSendMessagesToExternal);
  @ViewChild('fileInput') fileInput: FileUpload;

  public addMessageForm: FormGroup = new FormGroup({
    Person: new FormControl('', [Validators.required]),
    ExternalEmail: new FormControl('', CustomEmail.validate),
    Subject: new FormControl('', [Validators.required]),
    Body: new FormControl('', [Validators.required]),
    HighImportance: new FormControl('')
  });

  person = this.addMessageForm.get('Person');
  externalEmail = this.addMessageForm.get('ExternalEmail');
  subject = this.addMessageForm.get('Subject');
  body = this.addMessageForm.get('Body');
  highImportance = this.addMessageForm.get('HighImportance');

  constructor(private messageSvc: MessageService
      , private _global: GlobalService
      , private confirmationSvc: ConfirmationService) { }

  ngOnInit() {
    this.propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    this.subscription = this.messageSvc.findRecipientByProperty(this.propertyId)
      .subscribe((res: RecipientGroup) => {
        this.recipientGroup = res['data'][0];
        this.subject.setValue(this.recipientGroup.Subject);
        this.person.setValue(this.recipientGroup.Recipient.filter((resp) => resp.IsSelected));
        this.items = this.generateSelectItems(this.recipientGroup);
        this.recipients = true;
    }, error => {
      this.recipients = false;
      this.onError();
    });
  }

  generateSelectItems(recipients: RecipientGroup): SelectItem[] {
    const selectItems: SelectItem[] = [];
    if (recipients.AvailableGroup.length) {
      for (const groupKey of recipients.AvailableGroup) {
        selectItems.push({label: groupKey, value: groupKey, disabled: true});
        for (const item of recipients.Recipient) {
          if (item.GroupKey === groupKey) {
            selectItems.push({label: item.DisplayName, value: item, disabled: false});
          }
        }
      }
    }
    return selectItems;
  }

  uploadFile(event) {
    this.files = event.files;
  }

  clearformdata() {
    this.fileInput.clear();
    this.person.setValue([]);
    this.externalEmail.setValue('');
    this.subject.setValue('');
    this.body.setValue('');
    this.highImportance.setValue('');
    this.addMessageForm.markAsPristine();
    this.addMessageForm.markAsUntouched();
  }

  onSubmit() {
    this.fileInput.upload();
    if (this.addMessageForm.valid && this.checkFilecount()) {
      this.processing = true;
      const formData = this.toFormData(this.files);
      formData.append('message', JSON.stringify(this.addMessageForm.value));
      this.subscription = this.messageSvc.addMessage(formData, this.propertyId)
        .subscribe((res: any) => {
          this.processing = false;
          if (res.data[0].emailSent) {
            this.onSuccess();
          } else {
            this.onError();
          }
      }, error => {
        this.onError();
      });
    }
  }

  toFormData<T>( formValue: T ) {
    const formData = new FormData();
    for ( const key of Object.keys(formValue) ) {
      const value = formValue[key];
      formData.append('files_' + key, value);
    }
    return formData;
  }

  checkFilecount() {
    if (this.files.length && this.files.length > 5) {
      this.confirmationSvc.confirm({
        message: 'Please upload not more than 5 files',
      });
      return false;
    } else if (this.files.length) {
      var isValidFile = true;
      var allowedExtension = ['jpeg', 'jpg', 'png', 'xls', 'xlsx', 'pdf', 'doc', 'docx', 'txt'];
      for(var i = 0; i < this.files.length; i++) {
        var thisFileName = this.files[i].name;
        var thisFileExtensionArray = thisFileName.split('.');
        var thisFileExtensionString = thisFileExtensionArray[thisFileExtensionArray.length - 1].toLowerCase();
        if(!allowedExtension.includes(thisFileExtensionString)) {
          isValidFile = false;
        }
      }
      if(!isValidFile) {
        alert("The file type uploaded is not an Equator Approved file type. Equator approved file types are .pdf, .xls, .xlsx, .doc, .docx, .jpg, and .txt.");
        return false;
      }
    }
    return true;
  }

  cancelMessage() {
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const noteSummaryAll = `${(<any>_GlobalNS).routes.property.noteSummaryAll}&property_id=${propertyId}`;
    this._global.document.location.href = noteSummaryAll;
  }

  onSuccess() {
    this.clearformdata();
    this.messages = [{severity: 'success', summary: 'Your message has been sent successfully', detail: ''}];
    this.confirmationSvc.confirm({
      message: 'Your message has been sent successfully',
      accept: () => {
        const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
        const noteSummaryAll = `${(<any>_GlobalNS).routes.property.noteSummaryAll}&property_id=${propertyId}`;
        this._global.document.location.href = noteSummaryAll;
      }
    });
  }

  onError() {
    this.processing = false;
    this.clearformdata();
    this.messages = [{severity: 'error', summary: 'Error Occurred While Processing', detail: ''}];
  }

  personByGroupKey(groupKey): any {
    this.displayItems = [];
    for (const resp of this.person.value) {
      if (resp && resp.GroupKey.toLowerCase() === groupKey.toLowerCase()) {
        this.displayItems.push(resp.DisplayName);
      }
    }
    if (!this.displayItems.length) {
      this.displayItems.push('None');
    }
    return this.displayItems;
  }

  formValid(): boolean {
    return (!this.recipients || this.processing || this.addMessageForm.invalid);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
